export const createDefaultObj = () => {
  const today = new Date()
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000)

  today.setHours(0, 0, 0, 0)
  tomorrow.setHours(0, 0, 0, 0)

  return {
    '0': {
      peak: true,
      timeSlots: [
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    '1': {
      peak: false,
      timeSlots: [
        '9:00am - 11:00am',
        '10:00am - 12:00pm',
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    '2': {
      peak: false,
      timeSlots: [
        '9:00am - 11:00am',
        '10:00am - 12:00pm',
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    '3': {
      peak: false,
      timeSlots: [
        '9:00am - 11:00am',
        '10:00am - 12:00pm',
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    '4': {
      peak: false,
      timeSlots: [
        '9:00am - 11:00am',
        '10:00am - 12:00pm',
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    '5': {
      peak: false,
      timeSlots: [
        '9:00am - 11:00am',
        '10:00am - 12:00pm',
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    '6': {
      peak: true,
      timeSlots: [
        '9:00am - 11:00am',
        '10:00am - 12:00pm',
        '11:00am - 13:00pm',
        '12:00pm - 14:00pm',
        '13:00pm - 15:00pm',
        '14:00pm - 16:00pm',
        '15:00pm - 17:00pm'
      ]
    },
    startDate: today.toISOString(),
    endDate: tomorrow.toISOString()
  }
}

//turns timeslot string into array => [startHr, startMin, endHr, endMin]
//e.g. '10:00am - 11:15am' => [10, 0, 11, 15]
export const parseTime = str => {
  let regex = /(?<startHr>\d{1,2}):(?<startMin>\d{1,2}).*\s-\s(?<endHr>\d{1,2}):(?<endMin>\d{1,2}).*/
  let groups = str.match(regex).groups
  let toReturn = []
  Object.keys(groups).map(key => {
    toReturn.push(parseInt(groups[key]))
  })
  return toReturn
}

export const toTimeString = (array, hourPadding = false) => {
  let startHour = array[0] < 10 && hourPadding ? '0' + array[0] : '' + array[0]
  let endHour = array[2] < 10 && hourPadding ? '0' + array[2] : '' + array[2]
  let startMinutes = array[1] < 10 ? '0' + array[1] : '' + array[1]
  let endMinutes = array[3] < 10 ? '0' + array[3] : '' + array[3]
  let startSuffix = array[0] < 12 ? 'am' : 'pm'
  let endSuffix = array[2] < 12 ? 'am' : 'pm'
  return (
    startHour +
    ':' +
    startMinutes +
    startSuffix +
    ' - ' +
    endHour +
    ':' +
    endMinutes +
    endSuffix
  )
}

//Making this function because complier can't infer nullish coalescing operator
export const nullCoalesce = (value, fallback = '') => {
  return value === null || value === undefined ? fallback : value
}
